/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sub_Upgrade_Due_TodayInputs */



/**
* | output |
* | --- |
* | "Due today" |
*
* @param {Sub_Upgrade_Due_TodayInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_upgrade_due_today = /** @type {((inputs?: Sub_Upgrade_Due_TodayInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Upgrade_Due_TodayInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Heute fällig")
	return /** @type {LocalizedString} */ ("Due today")
});